import { debounce, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

import Dropdown from "@/components/form/Dropdown/Dropdown";
import FilterIcon from "@/components/icons/FilterIcon/FilterIcon";
import ListIcon from "@/components/icons/ListIcon/ListIcon";
import { COLORS } from "@/styles/theme";

const defaultSortOptions = [
  { name: "Titel (a-z)", value: "title" },
  { name: "Titel (z-a)", value: "-title" },
  { name: "Auteur (a-z)", value: "author" },
  { name: "Auteur (z-a)", value: "-author" },
  { name: "Datum (oud-nieuw)", value: "date_created" },
  { name: "Datum (nieuw-oud)", value: "-date_created" },
];

const defaultContentOptions = [
  { name: "Alle activiteiten", value: "" },
  { name: "Luisteren", value: "audio", icon: "👂🏼" },
  { name: "Lezen", value: "tip", icon: "📖" },
  { name: "Doen", value: "assignment", icon: "✍️" },
  { name: "Kijken", value: "vlog", icon: "👀" },
];

type Props = {
  /** The time the field will wait before triggering the callback */
  waitTime?: number;

  /** The availabled options used to sort */
  sortOptions?: typeof defaultSortOptions;

  contentOptions?: typeof defaultContentOptions;

  /** The callback that will be called when the user searches */
  onSort?: (_x: string) => void;

  onTypeContent?: (_x: string) => void;

  hasContentOptionsFilter?: boolean;
};

export default function SortBar({
  sortOptions = defaultSortOptions,
  contentOptions = defaultContentOptions,
  onSort,
  onTypeContent,
  hasContentOptionsFilter,
  waitTime = 300,
}: Props) {
  const { register } = useForm();

  const handleSort = (x: string) => {
    if (onSort) return onSort(x);
  };

  const handleContentTypes = (x: string) => {
    if (onTypeContent) return onTypeContent(x);
  };

  const debouncedSort = debounce(handleSort, waitTime);
  const debouncedContentSort = debounce(handleContentTypes, waitTime);

  return (
    <>
      {!hasContentOptionsFilter && (
        <Dropdown
          name="sort"
          placeholder="Sorteer op"
          register={register}
          onChange={debouncedSort}
          iconLeft={<ListIcon />}
          options={sortOptions}
          chevronColor={COLORS.black.normal}
          placeholderClass={"text-black"}
        />
      )}

      {hasContentOptionsFilter && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Dropdown
              name="sort"
              placeholder="Sorteer op"
              register={register}
              onChange={debouncedSort}
              iconLeft={<ListIcon />}
              options={sortOptions}
              chevronColor={COLORS.black.normal}
              placeholderClass={"text-black"}
            />
          </Grid>
          <Grid item xs={6}>
            <Dropdown
              name="activiteit"
              placeholder="Soort activiteit"
              register={register}
              onChange={debouncedContentSort}
              iconLeft={<FilterIcon />}
              options={contentOptions}
              chevronColor={COLORS.black.normal}
              placeholderClass={"text-black"}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
